/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable react/no-children-prop */
import {
  InputAdornment,
  TablePagination,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Loader,
  PrimarySelect,
  PrimaryTextField,
  StickyHeader,
} from 'components';
import { SearchIcon } from 'assets/icons';
import { IOption } from 'interfaces';
import { useDispatch, useSelector } from 'react-redux';
import Newsfeed from './components/newsfeed';
import AddNewsfeedModal from '../add-newsfeed-modal';
import { newsfeedAction } from './slice';
import {
  selectNewsfeeds, selectNewsfeedsLoader, selectNewsfeedsTotal,
} from './selector';

const NewsfeedList = () => {
  const dispatch = useDispatch();
  const sortByOptions: IOption[] = [
    {
      id: 'Default',
      value: 'Default',
      text: 'Default',
    },
    {
      id: 'title-asc',
      value: 'title-asc',
      text: 'Title ascending',
    },
    {
      id: 'title-desc',
      value: 'title-desc',
      text: 'Title descending',
    },
    {
      id: 'date-asc',
      value: 'date-asc',
      text: 'Oldest first',
    },
    {
      id: 'date-desc',
      value: 'date-desc',
      text: 'Latest first',
    },
  ];

  const [keyword, setKeyword] = React.useState<string>('');
  const [selectedSortBy, setSelectedSortBy] = useState(sortByOptions[0].id);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(18);
  const loading = useSelector(selectNewsfeedsLoader);
  const total = useSelector(selectNewsfeedsTotal);
  const newsfeeds = useSelector(selectNewsfeeds);

  useEffect(() => {
    dispatch(newsfeedAction.getNewsfeeds({
      keyword,
      page: (page + 1),
      limit: rowsPerPage,
      sortBy: selectedSortBy as string,
    }));
  }, [dispatch, selectedSortBy, keyword, page, rowsPerPage]);
  const handleSearchChange = (event: any) => {
    setKeyword(event.target.value);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 18));
    setPage(0);
  };

  return (
    <div data-testid="newsfeed-list">
      <StickyHeader>
        <div className="row mb-2">
          <div className=" col-lg-3 col-xl-2 mb-3 mb-md-0 d-flex flex-column justify-content-center">
            <Typography variant="h4" sx={{ mb: 0.5 }}>
              Newsfeed
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {!loading && `You have ${total} posts.`}
            </Typography>
          </div>
          <div className="col-lg-9 col-xl-10">
            <div className="row justify-content-lg-end gy-2 align-items-center gx-3 gx-lg-4">
              <div className="col-sm-4 col-lg-4 col-xl-3 mb-2 mb-md-0">
                <PrimaryTextField
                  placeholder="Search"
                  endAdornment={(
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )}
                  value={keyword}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="col-sm-4 col-lg-4 col-xl-3 mb-2 mb-md-0">
                <PrimarySelect
                  inlineLabel
                  label="Sort"
                  options={sortByOptions}
                  onChange={(e) => {
                    setSelectedSortBy(e.target.value as string);
                  }}
                />
              </div>
              <div className="col-sm-4 col-lg-4 col-xl-3 mb-2 mb-md-0">
                <AddNewsfeedModal />
              </div>
            </div>
          </div>
        </div>
      </StickyHeader>
      <Loader loading={loading ?? false}>
        <div
          className="row"
          style={{ overflowY: 'auto' }}
        >
          {newsfeeds.map((newsfeed) => (
            <Newsfeed key={newsfeed._id} newsfeed={newsfeed} />
          ))}
        </div>
        <div className="row my-3">
          <div className="col-12 d-flex flex-column align-items-center justify-content-center">
            <TablePagination
              aria-label="pagination"
              component="div"
              count={total}
              page={page}
              rowsPerPageOptions={[9, 18, 27, 36]}
              labelRowsPerPage="Items per page"
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </Loader>
    </div>
  );
};

export default NewsfeedList;
